import React from 'react';
import { Parallax, Background } from 'react-parallax';
export default {
  React,
  Parallax,
  Background
};